import { Menus } from './interfaces'

const profile = JSON.parse(localStorage.getItem('profile') || '[]')

let menus: Menus = [
  {
    id: 123,
    path: '/orders',
    sideMenuName: 'سفارش‌ها',
    icon: 'calendarClock'
  },
  {
    id: 400,
    path: '/parcels-menu',
    sideMenuName: 'محموله',
    icon: 'database',
    subMenu: [
      {
        id: 38,
        path: '/seller-parcels',
        icon: 'clipboard',
        sideMenuName: 'ارسال محموله'
      },
      {
        id: 21,
        path: '/parcels-sender',
        sideMenuName: 'ارسال محموله',
        icon: 'clipboard'
      },
      {
        id: 25,
        path: '/warehouse-admin-parcels-receipts',
        sideMenuName: ' محموله‌های دریافتی',
        icon: 'packageVariantClosed'
      }
    ]
  },
  {
    id: 22,
    path: '/your-products',
    sideMenuName: 'کالاها و موجودی',
    icon: 'archiveOutline'
  },
  // {
  //   id: 22,
  //   path: '/your-products',
  //   sideMenuName: 'مدیریت انبار',
  //   icon: "boxes",
  //   subMenu: [
  //     {
  //       id: 30,
  //       path: '/providers',
  //       sideMenuName: 'تامین‌کنندگان',
  //       icon: "user",
  //       hide: !profile.includes("PROVIDER_LIST")
  //     },
  //     {
  //       id: 31,
  //       path: '/sellers',
  //       sideMenuName: 'فروشندگان',
  //       icon: "user",
  //       hide: !profile.includes("SELLER_LIST")
  //     },
  //   ],
  // },
  {
    id: 120,
    path: '/wallet',
    sideMenuName: 'مالی',
    icon: 'finance',
    subMenu: [
      {
        id: 121,
        path: '/wallet',
        sideMenuName: 'کیف پول',
        icon: 'finance'
      },
      {
        id: 122,
        path: '/financial-management',
        sideMenuName: 'فاکتورها',
        icon: 'finance'
      },
      {
        id: 122,
        path: '/wallet/payments',
        sideMenuName: 'پرداختی ها',
        icon: 'finance'
      }
    ]
  },
  {
    id: 401,
    path: '/packaging',
    sideMenuName: 'بسته‌بندی',
    icon: 'box',
    subMenu: [
      {
        id: 411,
        path: '/packaging-consumption-report',
        sideMenuName: 'گزارش مصرف',
        icon: 'box'
      },
      {
        id: 421,
        path: '/packaging-preferences',
        sideMenuName: 'تنظیمات',
        icon: 'box'
      }
    ]
  },
  {
    id: 500,
    path: '/alltickets',
    sideMenuName: 'پشتیبانی',
    icon: 'headset',
    // disabled: process.env.REACT_APP_ENVIROMENT == "sandbox",
    subMenu: [
      {
        id: 501,
        path: '/tickets',
        sideMenuName: 'تیکت‌ها',
        icon: 'headset',
        disabled: process.env.REACT_APP_ENVIROMENT == 'sandbox'
      },
      {
        id: 502,
        path: '/messages',
        sideMenuName: 'مرکز پیام',
        icon: 'headset',
        disabled: process.env.REACT_APP_ENVIROMENT == 'sandbox'
      },
      {
        id: 503,
        path: '/videos',
        sideMenuName: 'ویدئوهای آموزشی',
        icon: 'cameraMovie'
      }
    ]
  },
  {
    id: 600,
    path: '/setting',
    sideMenuName: 'تنظیمات',
    icon: 'settings',
    subMenu: [
      {
        id: 23,
        path: '/your-centers',
        sideMenuName: 'مدیریت مراکز',
        icon: 'mapMarker',
        hide: !profile.includes('ORDER_FROM_CENTER')
      },
      {
        id: 24,
        path: '/integration',
        sideMenuName: 'یکپارچگی',
        icon: 'mapMarker'
      },
      {
        id: 117,
        path: '/notification',
        sideMenuName: 'اعلان‌ها',
        icon: 'bell'
      },
      {
        id: 118,
        path: '/contacts',
        sideMenuName: 'مخاطبین',
        icon: 'bell'
      },
      {
        id: 38,
        path: '/webhooks',
        icon: 'Web',
        sideMenuName: 'وب‌هوک'
      }
    ]
  },
  {
    id: 37,
    path: '/seller-orders',
    icon: 'packageVariant',
    sideMenuName: 'سفارش‌ها'
  },
  {
    id: 42,
    path: '/seller-products',
    sideMenuName: 'مدیریت کالاها',
    icon: 'archiveOutline'
  }
]

export default menus
